class PortfolioModalSrv {

	constructor ($mdDialog) {
		let addUserComment = () => {
			return $mdDialog.show({
				controller         : 'AddUserCommentCtrl',
				controllerAs       : 'commentUserVm',
				template           : require('./myPortfolio/modals/addUserComment.html'),
				clickOutsideToClose: false,
			})
		}    

		let addReflectionComment = () => {
			return $mdDialog.show({
				controller         : 'AddReflectionCommentCtrl',
				controllerAs       : 'reflectionCommentVm',
				template           : require('./myPortfolio/modals/addReflectionComment.html'),
				clickOutsideToClose: false,
			})
		}    

		let addNewRegistry = () => {
			return $mdDialog.show({
				controller         : 'AddNewRegistryCtrl',
				controllerAs       : 'registryVm',
				template           : require('./myPortfolio/modals/addNewRegistry.html'),
				clickOutsideToClose: false,
			})
		}    

		let evidenceLinks = () => {
			return $mdDialog.show({
				controller         : 'EvidenceLinksCtrl',
				controllerAs       : 'linksVm',
				template           : require('./myPortfolio/modals/evidenceLinks.html'),
				clickOutsideToClose: false,
			})
		}    

		let disableEvidence = () => {
			return $mdDialog.show({
				controller         : 'DisableEvidenceCtrl',
				controllerAs       : 'disableVm',
				template           : require('./myPortfolio/modals/disableEvidence.html'),
				clickOutsideToClose: false,
			})
		}    

		let editEvidence = () => {
			return $mdDialog.show({
				controller         : 'EditEvidenceCtrl',
				controllerAs       : 'editEvidenceVm',
				template           : require('./myPortfolio/modals/editEvidence.html'),
				clickOutsideToClose: false,
			})
		}  

		let editStatement = () => {
			return $mdDialog.show({
				controller         : 'EditStatementCtrl',
				controllerAs       : 'statementVm',
				template           : require('./myPortfolio/modals/editStatement.html'),
				clickOutsideToClose: false,
			})
		} 

		let historyStatement = () => {
			return $mdDialog.show({
				controller         : 'HistoryStatementCtrl',
				controllerAs       : 'historyVm',
				template           : require('./myPortfolio/modals/historyStatement.html'),
				clickOutsideToClose: false,
			})
		} 

		let commentDetails = () => {
			return $mdDialog.show({
				controller         : 'CommentDetailsCtrl',
				controllerAs       : 'commentDetailVm',
				template           : require('./myPortfolio/modals/commentDetails.html'),
				clickOutsideToClose: false,
			})
		} 

		let confirmDialog = () => {
			return $mdDialog.show({
				controller         : 'ConfirmDialogCtrl',
				controllerAs       : 'disableAccessVm',
				template           : require('./sharedPortfolio/modals/confirmDialog.html'),
				clickOutsideToClose: false,
			})
		} 

		let editReflection = () => {
			return $mdDialog.show({
				controller         : 'EditReflectionCtrl',
				controllerAs       : 'editReflectionVm',
				template           : require('./myPortfolio/modals/editReflection.html'),
				clickOutsideToClose: false,
			})
		} 
	
		let deleteReflection = () => {
			return $mdDialog.show({
				controller         : 'DeleteReflectionCtrl',
				controllerAs       : 'deleteReflectionVm',
				template           : require('./myPortfolio/modals/deleteReflection.html'),
				clickOutsideToClose: false,
			})
		}

		let showGuidelineDetails = () => {
			return $mdDialog.show({
				controller         : 'GuidelineDetailsCtrl',
				controllerAs       : 'guidelineVm',
				template           : require('./parametrization/modals/guidelineDetails.html'),
				clickOutsideToClose: false,
			})
		}  

		// forma para pasar valores entre modales. El set desde el padre,
		// el get desde el hijo (modal)
		let reusableVariable = null

		function setVariable (variable) {
			reusableVariable = variable

			return reusableVariable
		}

		function getVariable () {
			let unload = reusableVariable

			reusableVariable = null

			return unload
		}

		return {
			addUserComment      : addUserComment,
			addReflectionComment: addReflectionComment,
			addNewRegistry      : addNewRegistry,
			setVariable         : setVariable,
			getVariable         : getVariable,
			evidenceLinks       : evidenceLinks,
			disableEvidence     : disableEvidence,
			editEvidence        : editEvidence,
			editStatement       : editStatement,
			historyStatement    : historyStatement,
			commentDetails      : commentDetails,
			confirmDialog       : confirmDialog,
			editReflection      : editReflection,
			deleteReflection    : deleteReflection,
			showGuidelineDetails: showGuidelineDetails,
		}
	}

}

PortfolioModalSrv.$inject = [ '$mdDialog' ]

export default angular.module('services.PortfolioModalSrv', []).service('PortfolioModalSrv', PortfolioModalSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/portfolioModalSrv.js